import * as types from "../../mutationTypes";
import customerService from "services/customerService";

const actions = {
  async setFilterArea ({ dispatch, commit }, area) {
    await commit(types.CUSTOMER_AREA_FILTER, {
      area: area
    });
  },
  async setFilterCompanyName ({ dispatch, commit }, companyName) {
    await commit(types.CUSTOMER_COMPANY_NAME_FILTER, {
      companyName: companyName
    });
  },
  async getAll ({ commit, state, dispatch}, force) {
    if (!state.items || state.items.length === 0 || force) {
      dispatch('app/loadingDataEnable', 'customers', {root: true});
      const customers = await customerService.findAll();
      await commit(types.CUSTOMER_LIST, {
        items: customers || []
      });
      dispatch('app/loadingDataDisable', 'customers', {root: true});
    }
  },
  async create ({dispatch}, customer) {
    let response = await customerService.create(customer);
    if (response) {
      await dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  },
  async update ({dispatch}, customer) {
    let response = await customerService.update(customer);
    if (response) {
      await dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  },
  async delete ({dispatch}, id) {
    try {
      let response = await customerService.delete(id);
      if (response.ok) {
        await dispatch('getAll', true);
        return true;
      } else {
        return false;
      }
    } catch (ex) {
      console.error(ex);
    }
  },
  async activate ({ dispatch }, id) {
    try {
      let response = await customerService.activate(id);
      if (response.ok) {
        await dispatch('getAll', true);
        return true;
      } else {
        return false;
      }
    } catch (ex) {
      console.error(ex);
    }
  },
  async deactivate ({ dispatch }, id) {
    try {
      let response = await customerService.deactivate(id);
      if (response.ok) {
        await dispatch('getAll', true);
        return true;
      } else {
        return false;
      }
    } catch (ex) {
      console.error(ex);
    }
  }

};

export default actions



// WEBPACK FOOTER //
// ./client/store/modules/customer/customerActions.js